<div class="odontograma-config">
  <mat-card class="config-card mat-elevation-z4">
    <div class="config-header">Personalización del odontograma</div>

    <div class="grupo">
      <h3>Condiciones por cara</h3>
      <ng-container *ngFor="let c of porCara">
        <div class="fila" *ngIf="!c.oculto">
          <input type="color" [(ngModel)]="c.color" class="color-input" />
          <input type="text" [(ngModel)]="c.nombre" class="nombre-input" placeholder="Nombre de la condición" />
          <div class="borrar divIcon" (click)="eliminar('porCara', c)" title="Eliminar">
            <mat-icon class="icon">delete_forever</mat-icon>
          </div>
        </div>
      </ng-container>
      <button class="btn-agregar" type="button" (click)="agregar('porCara')">+ Agregar condición</button>
    </div>

    <div class="grupo">
      <h3>Condiciones por diente</h3>
      <ng-container *ngFor="let c of porDiente">
        <div class="fila" *ngIf="!c.oculto">
          <input type="color" [(ngModel)]="c.color" class="color-input" />
          <input type="text" [(ngModel)]="c.nombre" class="nombre-input" placeholder="Nombre de la condición" />
          <div class="borrar divIcon" (click)="eliminar('porDiente', c)" title="Eliminar">
            <mat-icon class="icon">delete_forever</mat-icon>
          </div>
        </div>
      </ng-container>
      <button class="btn-agregar" type="button" (click)="agregar('porDiente')">+ Agregar condición</button>
    </div>

    <div class="acciones">
      <button class="btn-guardar" (click)="guardar()" [disabled]="guardando">Guardar</button>
    </div>
  </mat-card>
</div>
